import { OnboardingMessages } from './messages';

/**
 * Traducción al Español para el plugin de onboarding.
 */
export const es: OnboardingMessages = {
  /* ── Encabezado de páginas ──────────────────────── */
  rolePageTitle: 'Onboarding del Desarrollador',
  rolePageSubtitle: 'Aprende a navegar en el IDP',
  trackPageSubtitle: 'Aprende a navegar en el IDP',

  /* ── Página de selección de rol ─────────────────── */
  roleQuestion: '¿Cuál es tu rol?',
  startAs: 'Comenzar como {{role}}',
  comingSoon: 'Próximamente',

  /* ── Página de track ────────────────────────────── */
  changeRole: 'Cambiar Rol',
  startJourney: 'Iniciar Jornada',
  reviewJourney: 'Revisar Jornada',
  warningMessage:
    '¡Debes completar el proceso de onboarding para usar la plataforma!',
  journeyLabel: 'Jornada {{index}}',
  stepsCount: '{{count}} pasos',
  phasesCount: '{{count}} fases',
  journeysCount: '{{count}} jornadas',
  completed: 'Completado',

  /* ── Modal de paso / overlay ────────────────────── */
  back: 'Atrás',
  continueLabel: 'Continuar',
  finish: 'Finalizar',
  stepIndicator: 'Paso {{current}}/{{total}}',

  /* ── Roles ──────────────────────────────────────── */
  roleDeveloperTitle: 'Desarrollador',
  roleDeveloperDescription: 'Codifico y despliego mi servicio',
  roleDeveloperDuration: '~70 min',
  roleDeveloperBadge: '+ Quiz',
  roleDeveloperPoint1: 'Navegar el Catálogo y encontrar servicios',
  roleDeveloperPoint2: 'Desplegar desde el código hasta producción',
  roleDeveloperPoint3: 'Solucionar problemas de pipeline y runtime',

  roleTechLeadTitle: 'Tech Lead',
  roleTechLeadDescription:
    'Creo servicios y gestiono la infraestructura de mi equipo',
  roleTechLeadDuration: '~75 min',
  roleTechLeadBadge: '+ Examen',
  roleTechLeadPoint1: 'Todo del track de Desarrollador',
  roleTechLeadPoint2: 'Crear nuevos servicios a partir de templates',
  roleTechLeadPoint3:
    'Aprovisionar recursos Azure (KeyVault, Storage, EventHub)',
  roleTechLeadPoint4: 'Gobernanza de API y scorecards',

  /* ── Títulos de jornadas ────────────────────────── */
  journeyNavigatingTitle: 'Navegando en el IDP',
  journeyDeployTitle: 'Deploy: Del Código a Producción',
  journeyTroubleshootTitle: 'Cuando Algo Sale Mal',
  journeyTemplatesTitle: 'Crear nuevos servicios a partir de templates',
  journeyAzureTitle: 'Aprovisionar recursos Azure',
  journeyApiTitle: 'Gobernanza de API y scorecards',
  journeyTeamTitle: 'Gestión de Equipo y Permisos',
  journeyCostTitle: 'Optimización de Costos y Monitoreo',

  /* ── Descripciones de jornadas ──────────────────── */
  journeyNavigatingDesc:
    'Entiende el portal, encuentra tu proyecto y aprende las herramientas y reglas.',
  journeyDeployDesc:
    'Aprende cómo desplegar tus servicios desde el código hasta producción.',
  journeyTroubleshootDesc:
    'Soluciona problemas de pipeline y runtime de forma efectiva.',
  journeyTemplatesDesc:
    'Crea nuevos servicios y componentes usando templates predefinidos.',
  journeyAzureDesc:
    'Configura y gestiona recursos de nube Azure para tu equipo.',
  journeyApiDesc:
    'Asegura la calidad y conformidad de las APIs con scorecards de gobernanza.',
  journeyTeamDesc:
    'Gestiona los miembros de tu equipo y configura permisos de acceso.',
  journeyCostDesc:
    'Monitorea costos y optimiza el uso de recursos en tus servicios.',

  /* ── Duraciones de jornadas ─────────────────────── */
  journeyNavigatingDurationDev: '~15 min',
  journeyNavigatingDurationTL: '~10 min',
  journeyDeployDuration: '~45 min',
  journeyTroubleshootDuration: '~10 min',
  journeyTemplatesDuration: '~10 min',
  journeyAzureDuration: '~15 min',
  journeyApiDuration: '~15 min',
  journeyTeamDuration: '~10 min',
  journeyCostDuration: '~10 min',

  /* ── Nombres de fases — Navegando en el IDP ─────── */
  phaseWelcome: 'Bienvenida y Descripción de la Plataforma',
  phaseNavigating: 'Navegando en Backstage',
  phaseFinding: 'Encontrando Tu Proyecto',
  phaseExternal: 'Descripción de Herramientas Externas',
  phasePermissions: 'Permisos y Reglas de Seguridad',

  /* ── Nombres de fases — Deploy ──────────────────── */
  phasePipeline: 'Descripción del Pipeline',
  phaseBuild: 'Build y Pruebas',
  phaseStaging: 'Despliegue a Staging',
  phaseProduction: 'Promoción a Producción',
  phaseMonitoringRollback: 'Monitoreo y Rollback',

  /* ── Nombres de fases — Troubleshoot ────────────── */
  phaseIdentifying: 'Identificando Problemas',
  phaseReadingLogs: 'Leyendo Logs',
  phasePipelineErrors: 'Errores Comunes de Pipeline',
  phaseDebugging: 'Debugging en Runtime',
  phaseEscalation: 'Procedimientos de Escalación',

  /* ── Nombres de fases — Templates ───────────────── */
  phaseTemplateGallery: 'Galería de Templates',
  phaseCreatingComponent: 'Creando un Componente',
  phaseConfiguring: 'Configurando Parámetros',
  phaseRepoSetup: 'Configuración del Repositorio',
  phaseFirstDeploy: 'Primer Despliegue',

  /* ── Nombres de fases — Azure ───────────────────── */
  phaseAzureOverview: 'Descripción de Recursos Azure',
  phaseKeyVault: 'Configuración de KeyVault',
  phaseStorage: 'Storage Account',
  phaseEventHub: 'Configuración de EventHub',
  phaseResourceMonitoring: 'Monitoreo de Recursos',

  /* ── Nombres de fases — API ─────────────────────── */
  phaseApiStandards: 'Estándares de API',
  phaseScorecard: 'Descripción de Scorecards',
  phaseRegisterApis: 'Registrando APIs',
  phaseCompliance: 'Verificaciones de Conformidad',
  phaseImprovingScores: 'Mejorando Puntuaciones',

  /* ── Nombres de fases — Equipo ──────────────────── */
  phaseTeamStructure: 'Estructura del Equipo',
  phaseRoleAccess: 'Acceso Basado en Roles',
  phasePermissionPolicies: 'Políticas de Permisos',
  phaseOnboardingMembers: 'Onboarding de Miembros',

  /* ── Nombres de fases — Costos ──────────────────── */
  phaseCostDashboard: 'Dashboard de Costos',
  phaseUsageAnalysis: 'Análisis de Uso',
  phaseOptimization: 'Consejos de Optimización',
  phaseBudgetAlerts: 'Alertas de Presupuesto',

  /* ── Títulos de sección de pasos ────────────────── */
  sectionWelcomePlatform: '1. Bienvenida y Descripción de la Plataforma',
  sectionNavigatingBackstage: '2. Navegando en Backstage',
  sectionFindingProject: '3. Encontrando Tu Proyecto',
  sectionExternalTools: '4. Descripción de Herramientas Externas',
  sectionPermissionsSecurity: '5. Permisos y Reglas de Seguridad',
  sectionBeforeStart: '1. Antes de empezar',
  sectionCICDPipeline: '2. El pipeline de CI/CD',
  sectionConfiguringApp: '3. Configurando tu aplicación',
  sectionBranchesLive: '4. Ramas e ir a producción',
  sectionMonitoringDeploys: '5. Monitoreando tus despliegues',

  /* ── Títulos de pasos de la jornada ─────────────── */
  stepWelcomeIdp: 'Bienvenido al IDP',
  stepToolsAroundYou: 'Las herramientas a tu alrededor',
  stepHowItConnects: 'Cómo se conecta todo',
  stepHomePage: 'La página de inicio',
  stepQuickActions: 'Acciones rápidas',
  stepSearchBar: 'La barra de búsqueda',
  stepOpenCatalog: 'Abrir el catálogo',
  stepUnderstandingKinds: 'Entendiendo los tipos',
  stepFiltersSearch: 'Filtros y búsqueda',
  stepFindSystem: 'Encuentra tu sistema',
  stepSystemOverview: 'Vista del sistema',
  stepRelationsGraph: 'Grafo de relaciones',
  stepArgoCd: 'ArgoCD: tu panel de despliegue',
  stepGrafana: 'Grafana: tus logs',
  stepGitHubAzureDevOps: 'GitHub y Azure DevOps',
  stepPermissionsDeveloper: 'Tus permisos como desarrollador',
  stepSecurityRules: 'Reglas de seguridad (obligatorio)',
  stepJourneyComplete: '¡Jornada completa!',
  stepTwoRepositories: 'Dos repositorios, un flujo',
  stepPlatformHandles: 'Lo que la plataforma maneja por ti',
  stepCompleteFlow: 'El flujo completo: push hasta aplicación en ejecución',
  stepPipelineStages: 'Tres etapas del pipeline',
  stepArgoCDAutoDeploy: 'ArgoCD se implementa automáticamente',
  stepComponentFile: 'El archivo de componente',
  stepEnvSecrets: 'Variables de entorno & secrets',
  stepResourcesHealth: 'Recursos & health checks',
  stepValidateYAML: 'Valida tu YAML antes de hacer commit',
  stepBranchMapping: 'Qué rama actualiza qué ambiente',
  stepGoingProduction: 'Yendo a producción',
  stepIndependentlyDo: 'Lo que puedes hacer por tu cuenta',
  stepCheckingArgoCD: 'Verificando despliegues en ArgoCD',
  stepCheckingLogs: 'Verificando logs en Grafana',

  /* -- Journey 3: When Something Goes Wrong ----------- */
  sectionJ3CheckLogs: '1. Revisa tus logs primero',
  stepJ3StartGrafana: 'Empieza con Grafana',
  stepJ3WhatToLookLogs: 'Qué buscar en los logs',
  sectionJ3CheckDeploy: '2. Revisa tu despliegue',
  stepJ3WhenNotInLogs: 'Cuando no está en los logs',
  stepJ3GitOpsMisconfiguration: 'Mala configuración en GitOps',
  stepJ3PipelineFailures: 'Fallos de pipeline',
  stepJ3ImageNotUpdating: 'Imagen no se actualiza (PullBackOff)',
  sectionJ3AskHelp: '3. Cuándo pedir ayuda',
  stepJ3OpenTicket: 'Abre un ticket',
  stepJ3Journey3Complete: '¡Jornada completada!',

  /* ── Quiz ────────────────────────────────────────── */
  sectionQuiz: 'Quiz',
  stepQuiz: 'Quiz',
  quizQuestionOf: 'Pregunta {{current}}/{{total}}',
  quizConfirm: 'Confirmar',
  quizCorrectAnswer: 'Respuesta correcta: {{letter}}',
  quizPassed: '¡Quiz aprobado!',
  quizFailed: 'Quiz no aprobado',
  quizCorrectAnswers: 'respuestas correctas',
  quizNextJourneyUnlocked: '¡Jornada 2: Deploy: del código a producción está desbloqueada!',
  quizNextSteps: 'Has completado las tres jornadas de Desarrollador y aprobado todas las validaciones. El acceso completo a la plataforma está desbloqueado.',
  quizContinueToJourney: 'Continuar a Jornada 2',
  quizFinishOnboarding: 'Finalizar Onboarding',
  quizTryAgain: 'Intentar de nuevo',
  quizStartQuiz: 'Iniciar Quiz',
  quizFailedMessage:
    'Necesitas al menos {{min}} de {{total}} correctas para aprobar. Revisa el contenido de la jornada e inténtalo de nuevo. Puedes repetir el quiz las veces que necesites.',
  quizReviewJourney: 'Revisar Jornada',
  playgroundGoToPlayground: 'Ir al Playground',

  /* ── Playground ───────────────────────────────────── */
  sectionPlayground: 'Playground',
  stepPlayground: 'Playground',
  playgroundTitle: '¡Hora del Playground!',
  playgroundDescription: 'Ahora es tu turno. Completa las tareas a continuación en el repositorio del Playground para validar lo que aprendiste.',
  playgroundTaskListHeader: 'Lo que harás:',
  playgroundTask1: 'Clonar el repositorio, crear una rama, hacer un cambio',
  playgroundTask2: 'Hacer merge a develop y observar la ejecución del pipeline',
  playgroundTask3: 'Verificar el deploy en ArgoCD (ambiente dv)',
  playgroundTask4: 'Promover a pre-producción vía rama release_candidate',
  playgroundTask5: 'Promover a producción vía merge a main + aprobación de PR',
  playgroundTutorialLabel: 'Abrir el tutorial completo',
  playgroundTutorialDescription: 'Instrucciones paso a paso para el ejercicio',
  playgroundRepoLabel: 'Abrir repositorio del playground (BFF)',
  playgroundVerifyHint: 'Cuando termines, haz clic en Verificar abajo. Comprobaremos si las tareas fueron completadas.',
  playgroundVerify: 'Verificar',
  playgroundCompleted: '¡Playground completado!',
  playgroundCompletedMessage: 'Verificamos tus acciones en el repositorio. Todo está correcto.',
  playgroundNextJourneyUnlocked: '¡Jornada 3: Cuando Algo Sale Mal está desbloqueada! Puedes iniciarla desde la página de onboarding.',
  playgroundContinueToJourney: 'Continuar a Jornada 3',
  playgroundFailedTitle: 'No pudimos confirmar la finalización',
  playgroundFailedMessage: 'Verificamos el repositorio del Playground pero no pudimos confirmar que todas las tareas fueron completadas. Es posible que aún tengas acciones pendientes.',
  playgroundFailedHint: 'Revisa el contenido de la jornada, asegúrate de haber completado todos los pasos en el repositorio, e intenta verificar nuevamente.',
  playgroundReviewJourney: 'Revisar Jornada',
  playgroundVerifyAgain: 'Verificar de nuevo',

  /* ── Confirmación de salida ───────────────────────── */
  exitConfirmTitle: '¿Salir del onboarding?',
  exitConfirmMessage: 'Tu progreso en esta jornada se perderá. Puedes reiniciarla en cualquier momento desde la página de la ruta.',
  exitConfirmLeave: 'Salir',
  exitConfirmStay: 'Quedarme',

  /* ── Selector de idioma ─────────────────────────── */
  languageLabel: 'Idioma',

  /* ── Prerrequisitos ─────────────────────────────── */
  prerequisitesTitle: 'Prerrequisitos',
  prerequisitesDescription: 'Antes de iniciar el onboarding, asegúrate de tener las siguientes licencias. Si no tienes alguna de ellas, solicítala a través de los enlaces a continuación.',
  prerequisiteGithubLicense: 'Licencia GitHub',
  prerequisiteGithubCopilot: 'Licencia GitHub Copilot',
  prerequisiteGithubCodespaces: 'Licencia GitHub Codespaces',
  prerequisitesAlignWithTechLead: 'Si no tienes alguna de estas licencias, alinéalo también con tu Tech Lead.',
  prerequisitesRequestAccess: 'Solicitar acceso aquí',
  prerequisitesHowToFill: 'Cómo completar la solicitud',

  /* ── NPS ─────────────────────────────────────────── */
  npsTitle: 'Feedback del Onboarding',
  npsDescription: 'Tu opinión es clave para mejorar la experiencia de onboarding del IDP. Esta encuesta es anónima y toma alrededor de 2 minutos. Los resultados guiarán las próximas evoluciones de la plataforma.',
  npsQuestionsCount: '{{count}} preguntas',
  npsBadge: '+ NPS',
  npsStart: 'Iniciar NPS',
  npsSubmitError: 'Error al enviar NPS. Inténtalo de nuevo.',
  reviewNps: 'Revisar NPS',
  npsThankYouSubtitle: 'Tus respuestas han sido registradas exitosamente.',
};
